module.exports = __webpack_public_path__ + "static/media/garage.984e690d.jpg";